import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useCallback } from 'react';
import { ProductColor, VariantDetails } from '../../relewise/types/mapped';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useDatalayerService } from './useDatalayerService';

interface UseAddToCartDatalayerParams {
    request: IRequestContext;
    telemetry: ITelemetry;
    productItemId: string | undefined;
    selectedVariant: VariantDetails | undefined;
    selectedColor: ProductColor | undefined;
    selectedSize: string | undefined;
    brand: string | undefined;
}

export const useAddToCartDatalayer = ({
    request,
    telemetry,
    productItemId,
    selectedVariant,
    selectedColor,
    selectedSize,
    brand
}: UseAddToCartDatalayerParams) => {
    const datalayerService = useDatalayerService({ request, telemetry });

    const trackAddToCart = useCallback(
        (overrides?: { size?: string; variant?: VariantDetails }) => {
            const size = overrides?.size ?? selectedSize;
            const variant = overrides?.variant ?? selectedVariant;
            if (!productItemId || !variant || !selectedColor || !size) {
                return;
            }

            datalayerService.pushAddToCart(productItemId, selectedColor.name, size, variant, brand);
        },
        [datalayerService, productItemId, selectedVariant, selectedColor, selectedSize, brand]
    );

    return trackAddToCart;
};
